<template>
  <div class="full-width-notice" :class="type">
    <p v-html="message"></p>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    type: { type: String, default: 'info' },
  }
};
</script>

<style scoped>
    .full-width-notice {
      padding: 15px;
      font-family: Arial, sans-serif;
      font-size: 16px;
      line-height: 2;
      text-align: center;
      min-height: 64px;
    }

    .full-width-notice a {
      text-decoration: none;
    }

    .full-width-notice a:hover {
      text-decoration: underline;
    }

    .info {
      background-color: #d4f0f7;
      border-bottom: 1px solid #a6e3ef;
      color: #0d6e80;
    }

    .info a {
      color: #0e7c92;
    }

    .warn {
      background-color: #fff7e6;
      border-bottom: 1px solid #ffdba3;
      color: #8a5700;
    }

    .warn a {
      color: #c07b00;
    }

    .error {
      background-color: #f8d7da;
      border-bottom: 1px solid #f1aeb5;
      color: #721c24;
    }

    .error a {
      color: #a71d2a;
    }
</style>
